import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ConditionalWrapper from '../ConditionalWrapper';

function Tab({
  index = 0,
  title = '',
  link = null,
  selected = false,
  contentLeft = null,
  contentRight = null,
  content = null,
  onClick = () => {},
  className = '',
  contentLeftClassName = '',
  contentRightClassName = '',
  contentClassName = '',
  spacerClassName = '',
}) {
  const linkClass = link ? 'FeedFloTabs-tabLink' : '';
  const selectedClass = selected ? 'selected' : '';
  const tabClassName = `FeedFloTabs-tab noselect ${linkClass} ${selectedClass} ${className}`;

  const onTabClick = () => {
    onClick(index);
  };

  const renderTabContent = () => {
    return (
      <ConditionalWrapper
        condition={link}
        conditionalWrapper={(children) => (
          <Link to={link} className={tabClassName} onClick={onTabClick}>
            {children}
          </Link>
        )}
        defaultWrapper={(children) => (
          <div role="button" tabIndex={100 + index} className={tabClassName} onClick={onTabClick}>
            {children}
          </div>
        )}
      >
        <div className={`FeedFloTabs-tab-contentLeft ${contentLeftClassName}`}>{contentLeft}</div>
        {content ? (
          <div className={`FeedFloTabs-tab-content ${contentClassName}`}>{content}</div>
        ) : (
          <span className={`FeedFloTabs-tab-title ${contentClassName}`}>{title}</span>
        )}
        <div className={`FeedFloTabs-tab-contentRight ${contentRightClassName}`}>{contentRight}</div>
      </ConditionalWrapper>
    );
  };

  return (
    <>
      {renderTabContent()}
      <div className={`spacer ${spacerClassName}`} />
    </>
  );
}

Tab.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  link: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  content: PropTypes.any,
  contentLeft: PropTypes.any,
  contentRight: PropTypes.any,
  className: PropTypes.string,
  contentLeftClassName: PropTypes.string,
  contentRightClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  spacerClassName: PropTypes.string,
};

export default Tab;
